import './searchIcon.css';

export default function SearchIcon() {
    return(
        <div className="search-icon">
            <svg width="27.227" height="27.227" viewBox="0 0 27.227 27.227">
                <path id="Icon_ion-search-sharp" data-name="Icon ion-search-sharp" d="M30.6,28.246l-8.121-8.122a10.57,10.57,0,1,0-2.358,2.358L28.246,30.6ZM13.933,21.157a7.224,7.224,0,1,1,7.224-7.224,7.225,7.225,0,0,1-7.224,7.224Z" transform="translate(-3.375 -3.375)" fill="#72bf72"/>
            </svg>
        </div>
    )
}